import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/cal-cup")({
  loader: () => {
    throw redirect({ to: "/juniors/cal-cup" });
  },
});
